module.exports = __webpack_public_path__ + "static/media/Korean_Chung BG-21.9467a862.png";